import { render, staticRenderFns } from "./AgendaTimeSlot.vue?vue&type=template&id=dd95724a"
import script from "./AgendaTimeSlot.vue?vue&type=script&lang=js"
export * from "./AgendaTimeSlot.vue?vue&type=script&lang=js"
import style0 from "./AgendaTimeSlot.vue?vue&type=style&index=0&id=dd95724a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports